import React, { useState, useEffect } from 'react'
import { Link, Redirect } from 'react-router-dom'

import Axios from 'axios'
import '../custom.css'
import K from '../services/k'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEnvelope,
  faPhoneSquare,
  faUnlockAlt,
  faUser,
  faUtensils,
} from '@fortawesome/free-solid-svg-icons'

function SignUp(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const history = useHistory()
  const token = localStorage.getItem(['__react_session__'])

  const jsontoken = JSON.parse(token)
  let first_name = ''
  let user_email = ''

  if (jsontoken !== '' && jsontoken !== null) {
    if (jsontoken.api_token) {
      history.push('/')
    }
  }
  // const classes = useStyles();

  //const dispatch = useDispatch();

  //const authResponse = useSelector(state=>state.userAuth.authResponse);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [fields, setState] = useState({
    first_name: '',
    last_name: '',
    phone_number: '',
    email: '',
    password: '',
    password_confirmation: '',
  })

  const handleFieldChange = (e) => {
    setState({
      ...fields,
      [e.target.id]: e.target.value,
    })
  }
  //please wait spinner
  const [spinnerStatus, setSpinnerStatus] = useState(0)
  const [spinnerMessage, setSpinnerMessage] = useState('')
  //redirect on successful register
  const [redirect, setredirect] = useState(0)

  const UserRegister = async (e) => {
    e.preventDefault()
    setSpinnerStatus(1)
    const passwordMatch = checkPasswordMatch(
      fields.password,
      fields.password_confirmation,
    )
    if (
      fields.first_name === '' ||
      fields.last_name === '' ||
      fields.phone_number === '' ||
      fields.email === '' ||
      fields.password === '' ||
      fields.password_confirmation === ''
    ) {
      setSpinnerStatus(2)
      setSpinnerMessage('All fields required')
      return false
    } else if (passwordMatch === true) {
      setSpinnerStatus(2)
      setSpinnerMessage(
        'passwords dont match. please check your password again',
      )
      // alert('passwords dont match. please check your password again');
      return false
    } else {
      const resp = await Axios.post(`${K.baseUrl}users/register`, fields)
      if (resp.data.resultcode === '0') {
        setSpinnerStatus(2)
        setSpinnerMessage(resp.data.message)
      } else if (resp.data.resultcode === '1') {
        setTimeout(function () {
          setredirect(1)
        }, 2000)

        setSpinnerStatus(3)
        setSpinnerMessage('Registration successful.Please proceed to login')
      } else {
        setSpinnerStatus(2)
        setSpinnerMessage('Unexepected error occured.Consult system Admin')
      }
    }
  }

  const checkPasswordMatch = (password, password_confirmation) => {
    return password !== password_confirmation ? true : false
  }

  if (redirect === 1) {
    return <Redirect to="/login" />
  } else {
    return (
      <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
        <div
          className="main-wrapper__ inner--page"
          style={{ paddingTop: '-90px' }}
        >
          <section className="login">
            <div className="container">
              <div className="row mt-5 pt-5 pb-4">
                <div className="col-lg-6 offset-lg-3 col-md-6 offset-md-3">
                  <div className="login-content">
                    <div className="heading-text text-center">
                      <h3>Sign Up</h3>
                      <p className="normalText">
                        ...open an account for free &#38; start Ordering{' '}
                        <FontAwesomeIcon
                          style={{ color: '#42B749' }}
                          icon={faUtensils}
                        />
                      </p>
                      <br />
                    </div>

                    <p className="normalText">or</p>

                    <div className="login-form noflex">
                      <form onSubmit={UserRegister}>
                        <div className="form-container">
                          <FontAwesomeIcon
                            style={{ position: 'absolute', margin: '15px' }}
                            icon={faUser}
                          />
                          <input
                            type="text"
                            name="first_name"
                            placeholder="First Name"
                            id="first_name"
                            value={fields.first_name}
                            onChange={handleFieldChange}
                            required
                          />
                        </div>
                        <div className="form-container">
                          <FontAwesomeIcon
                            style={{ position: 'absolute', margin: '15px' }}
                            icon={faUser}
                          />
                          <input
                            type="text"
                            name="last_name"
                            placeholder="Last Name"
                            id="last_name"
                            value={fields.last_name}
                            onChange={handleFieldChange}
                            required
                          />
                        </div>
                        <div className="form-container">
                          <FontAwesomeIcon
                            style={{
                              position: 'absolute',
                              margin: '15px',
                              transform: 'rotate(90deg)',
                            }}
                            icon={faPhoneSquare}
                          />
                          <input
                            type="text"
                            name="phone_number"
                            placeholder="Phone Number"
                            id="phone_number"
                            value={fields.phone_number}
                            onChange={handleFieldChange}
                            required
                          />
                        </div>
                        <div className="form-container">
                          <FontAwesomeIcon
                            style={{ position: 'absolute', margin: '15px' }}
                            icon={faEnvelope}
                          />
                          <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            id="email"
                            value={fields.email}
                            onChange={handleFieldChange}
                            required
                          />
                        </div>
                        <div className="form-container">
                          <FontAwesomeIcon
                            style={{ position: 'absolute', margin: '15px' }}
                            icon={faUnlockAlt}
                          />
                          <input
                            type="Password"
                            name="Password"
                            placeholder="Password"
                            id="password"
                            value={fields.password}
                            onChange={handleFieldChange}
                            required
                          />
                        </div>
                        <div className="form-container">
                          <FontAwesomeIcon
                            style={{ position: 'absolute', margin: '15px' }}
                            icon={faUnlockAlt}
                          />
                          <input
                            type="Password"
                            name="password_confirmation"
                            placeholder="Confirm Password"
                            id="password_confirmation"
                            value={fields.password_confirmation}
                            onChange={handleFieldChange}
                            required
                          />
                        </div>

                        <div className="form-container text-left">
                          {spinnerStatus === 1 ? (
                            <span>
                              <p className="text-spinner-font">
                                <i className="fa fa-spinner fa-spin spinner-font"></i>
                                &nbsp;Please Wait...
                              </p>
                            </span>
                          ) : spinnerStatus === 2 ? (
                            <div className="alert alert-danger">
                              {spinnerMessage}
                            </div>
                          ) : spinnerStatus === 3 ? (
                            <div className="alert alert-success">
                              {spinnerMessage}
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                        <div>
                          <p className="normalText">
                            by signing up you agree to our{' '}
                            <Link to="/termsandconditions">
                              <span className="colorgreen">
                                <b>Terms and Conditions</b>
                              </span>
                            </Link>
                          </p>
                        </div>
                        <div className="form-group text-center">
                          {/* <a href="javascript:void;" className="primary-btn mb-2">
                        Signup
                      </a> */}
                          <button
                            className="primary-btn mb-2 fwidth"
                            type="submit"
                          >
                            SignUp
                          </button>

                          <p className="normalText">
                            Already have an account?{' '}
                            <Link to="/login">
                              <span className="colorgreen">
                                <b>Login here</b>
                              </span>
                            </Link>
                          </p>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    )
  }
}

export default SignUp
